








import Vue from "vue";
import { Component } from "vue-property-decorator";
import WsResponseModel from "../../../api/dataSource/api/SchemaBuilderServer/Models/WsResponseModel";
import NewsListRequest from "../../../api/dataSource/api/EducationSystem/PublicWeb/Api/Models/NewsModels/NewsListRequest";
import NewsListResponse from "../../../api/dataSource/api/EducationSystem/PublicWeb/Api/Models/NewsModels/NewsListResponse";
declare function initPortfolio() : void
@Component
export default class PageHomeComponent extends Vue {
  newsResponse: WsResponseModel<NewsListResponse> = null;
  
  constructor() {
    super();   
    this.$meta.setDefaultTitle();
  }
  created() {    
  }
  mounted() {
    this.$api.NewsService.GetListEvent.once(this.onGetList.bind(this));
    this.$api.NewsService.GetList({
      Take:6
    }); 

    
  }
  onGetList(response:WsResponseModel<NewsListResponse>){
    if(response.IsSuccess)
      for(var i in response.Value.Items){
        response.Value.Items[i].ImageUrl = `/assets/img/frontpage/image${Number(i)+1}.jpg`;
      }
    this.newsResponse = response;
    
            setTimeout(()=>{
                initPortfolio();
            },200)
  }
}
